import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const images = pageImages['wide-mouth-open-end-automatic-tie-balers'];

const wideMouthModelHeaders = ['Series', '5042', '6042', '6046', '7842', '7846'];

const wideMouthModelRows = [
  ['Hopper/Feed Opening (LxW)', '50 X 42', '60 X 42', '60 X 46', '78 X 42', '78 X 46'],
  ['Strokes Per Minute', '2 to 6', '2 to 6', '2 to 6', '2 to 6', '2 to 6'],
  ['Cylinder Bore', '7, 8 or 10', '7, 8 or 10', '7, 8 or 10', '8 or 10', '8 or 10'],
  ['Power Unit HP', '30 to 60', '30 to 60', '30 to 60', '30 to 100', '30 to 100'],
];

function WideMouthOpenEndAutomaticTieBalers() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link to="/closed-end-manual-tie-balers">Closed-End Manual Tie Balers</Link>
          <Link to="/open-end-automatic-tie-balers">Open-End Automatic Tie Balers</Link>
          <Link className="active" to="/wide-mouth-open-end-automatic-tie-balers">Wide-Mouth Open-End Automatic Tie Balers</Link>
          <Link to="/multi-materials-full-eject-closed-end-balers">Multi Materials Full-Eject Closed-End Balers</Link>
          <Link to="/open-end-manual-tie-balers">Open-End Manual Tie Balers</Link>
          <Link to="/cart-lifters-dumpers-dump-carts">Cart Lifters, Dumpers &amp; Dump Carts</Link>
          <Link to="/conveyors-bale-conveying-bagging-systems">Conveyors, Bale Conveying &amp; Bagging Systems</Link>
          <Link to="/used-clothing-balers">Used Clothing Balers</Link>
          <Link to="/cotton-gin-textile-baling-presses">Cotton Gin &amp; Textile Baling Presses</Link>
          <Link to="/biomass-cotton-gin-trash-baling-press">Biomass &amp; Cotton Gin Trash Baling Press</Link>
          <Link to="/vertical-down-packing-baling-presses-balers">Vertical &amp; Down-Packing Baling Presses &amp; Balers</Link>
          <Link to="/custom-designed-specialty-balers">Custom Designed &amp; Specialty Balers</Link>
          <Link to="/precrush-compactors-waste-compactors">PreCrush Compactors &amp; Waste Compactors</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Products</span>
          <h2>Wide-Mouth Open-End Automatic Tie Balers</h2>
          <div className="body-copy page-summary-copy"><strong>Wide-mouth automatic tying horizontal open-end balers</strong> are built for larger materials such as computer and equipment boxes, fiberglass sheeting, bulk materials, and high-volume baling of loose paper, OCC, and other recyclables at material recovery facilities, paper mills, distribution centers, manufacturing plants, and re-packaging centers. Consistently sized large and heavy bales are automatically tied and ejected with <strong>PLC controlled</strong> baler function sequencing. For single stream materials, these fast and efficient wide-mouths can out produce most two ram balers.</div>
          <div className="page-summary-notes">
            <span>Extra wide-mouth feed openings</span>
            <span>Automatic tying for higher throughput</span>
            <span>Useful for large or irregular material streams</span>
          </div>
          <PagePhotoViewer images={images} eyebrow="Equipment Photos" />
          <div className="content-stack">
            <div className="gold-note">Note: Extra heavy duty model for extreme usage ONLY AVAILABLE with 10&quot; or 12&quot; bore compression ram cylinder.</div>
            <section className="content-block">
              <h3>Standard Wide-Mouth Automatic Tie Models</h3>
              <div className="body-copy">The original wide-mouth table compares the larger <strong>feed openings</strong> and corresponding <strong>power ranges</strong> commonly used for bulky material streams and larger automatic tie systems.</div>
              <div className="spec-table-block">
                <table className="spec-table">
                  <thead>
                    <tr>{wideMouthModelHeaders.map((header) => <th key={header}>{header}</th>)}</tr>
                  </thead>
                  <tbody>
                    {wideMouthModelRows.map((row) => (
                      <tr key={row[0]}>{row.map((cell, cellIndex) => <td key={`${row[0]}-${cellIndex}`}>{cell}</td>)}</tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default WideMouthOpenEndAutomaticTieBalers;
